<template>
  <el-table class="table" row-class-name="row" empty-text="暂无数据(No Data)" v-bind="$attrs" border v-on="$listeners">
    <el-table-column v-if="selection" type="selection" width="26"/>
    <slot/>
  </el-table>
</template>

<style scoped>
  .table {
    width: 100%;
    font-size: 14px
  }
  .table >>> .row td {
    padding: 0;
    height: 35px;
  }
  .table >>> .cell {
    padding: 0 5px !important;
  }
  .table >>> .el-checkbox-button__inner {
    padding: 8px 15px;
    font-size: 15px;
  }
  .table >>> .el-checkbox-button__inner {
    padding: 8px 15px;
    font-size: 15px;
  }
  .table >>> .el-table__header th {
    padding: 8px 0;
  }
</style>
<script>
  export default {
    props: {
      selection: {
        type: Boolean,
        default: false
      }
    }
  }
</script>